import { forceLogout } from "./session";

const SUSPENDED_MESSAGE =
  "Akun Anda ditangguhkan oleh admin. Hubungi admin untuk informasi lebih lanjut.";

// Almost every page in this app calls raw fetch() directly rather than the
// shared axios instance (utils/api.js, used by exactly one page) — so a
// global fetch patch, installed once at bootstrap, is the one place that can
// catch a suspended-mid-session 401 (hasil meet.txt bug#2: an already-logged-in
// user whose account gets suspended just sees requests silently fail today)
// no matter which page's API call triggered it, without migrating every
// call site to axios.
let installed = false;

export function installAuthGuard() {
  if (installed) return;
  installed = true;

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    if (response.status === 401) {
      // Clone so the caller can still read the body itself — a Response
      // body can only be consumed once.
      response
        .clone()
        .json()
        .then((data) => {
          if (data && data.code === "account_suspended") {
            forceLogout({ message: SUSPENDED_MESSAGE });
          }
        })
        .catch(() => {
          // Not a JSON 401 body (e.g. a plain expired-token response with no
          // body at all) — nothing to check, leave the caller's own 401
          // handling (if any) to run normally.
        });
    }
    return response;
  };
}
